export default [
		{ id: 1, header: 'What is Slidy?', text: 'SLIDY – simple configurable carousel component on SvelteJS', src: 'https://picsum.photos/900/900.webp?random=1' },
		{ id: 2, header: 'What is Slidy?', text: 'SLIDY – simple configurable carousel component on SvelteJS',src: 'https://picsum.photos/1240/900.webp?random=2' },
		{ id: 3, header: 'What is Slidy?', text: 'SLIDY – simple configurable carousel component on SvelteJS',src: 'https://picsum.photos/1800/900.webp?random=3' },
	]
